import { EmptyState } from 'v2/shared/components/empty-state'

interface NatWarningPopoverContentProps {
  onClose: () => void
  onRetry: () => void
}

export const NatWarningPopoverContent = ({ onClose, onRetry }: NatWarningPopoverContentProps) => {
  return (
    <div className="w-80 p-4 pb-8">
      <EmptyState
        type="app_error"
        text={
          <div className="text-center mt-8">
            <div className="text-p-600 text-primary">Unable to test voice agents</div>
            <div className="mt-1 text-secondary">
              Your network is blocking voice connections. Try switching to a different network or
              contact your IT team for help.
            </div>
          </div>
        }
        actions={[
          { text: 'Retry', onClick: onRetry, variant: 'default' as const },
          { text: 'Close', onClick: onClose, variant: 'outline' as const },
        ]}
        className="pt-8"
      />
    </div>
  )
}
